const DOMAIN_HOST_ENUM = Object.freeze({
  MY_AZTRUCK: "my.aztruck.co",
  SOLS4: "aztruck.sols4.com",
  SOLS4_NEW: "aztruck-new.sols4.com",
  MY_AVTOMATIKA: "my.avtomatika.co",
  STAGING_AZTRUCK: "staging.aztruck.co",
});

const DEFAULT_STAGING_API_HOST = "api-staging.aztruck.co/api/v1/";
const DEFAULT_STAGING_FRONT_HOST = "staging.aztruck.co";
const SECURE_PROTOCOL = "https:";

const DOMAIN_API_HOST_ENUM = Object.freeze({
  [DOMAIN_HOST_ENUM.MY_AZTRUCK]: "api.aztruck.co/api/v1/",
  [DOMAIN_HOST_ENUM.SOLS4]: "api-aztruck.sols4.com/api/v1/",
  [DOMAIN_HOST_ENUM.SOLS4_NEW]: "api-aztruck-new.sols4.com/api/v1/",
  [DOMAIN_HOST_ENUM.MY_AVTOMATIKA]: "api.avtomatika.co/api/v1/",
  [DOMAIN_HOST_ENUM.STAGING_AZTRUCK]: "api-staging.aztruck.co/api/v1/",
});

const DOMAIN_FRONT_HOST_ENUM = Object.freeze({
  [DOMAIN_HOST_ENUM.MY_AZTRUCK]: "my.aztruck.co",
  [DOMAIN_HOST_ENUM.SOLS4]: "aztruck.sols4.com",
  [DOMAIN_HOST_ENUM.SOLS4_NEW]: "aztruck-new.sols4.com",
  [DOMAIN_HOST_ENUM.MY_AVTOMATIKA]: "my.avtomatika.co",
  [DOMAIN_HOST_ENUM.STAGING_AZTRUCK]: "staging.aztruck.co",
});

const LOCAL_HOSTNAMES = new Set(["localhost", "127.0.0.1", "[::1]"]);
const FALLBACK_PROTOCOL = "https:";

const stripProtocol = (value = "") => value.replace(/^https?:\/\//i, "");
const ensureTrailingSlash = (value = "") =>
  value ? (value.endsWith("/") ? value : `${value}/`) : "";

const getProtocol = () =>
  typeof window !== "undefined" && window.location?.protocol
    ? window.location.protocol
    : FALLBACK_PROTOCOL;

const getHostname = () =>
  typeof window !== "undefined" && window.location?.hostname
    ? window.location.hostname.toLowerCase()
    : "";

const isPrivateIpv4Host = (hostname = "") => {
  const match = hostname.match(/^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/);
  if (!match) {
    return false;
  }

  const [a, b] = [Number(match[1]), Number(match[2])];

  if (a === 10) return true;
  if (a === 192 && b === 168) return true;
  if (a === 172 && b >= 16 && b <= 31) return true;

  return false;
};

const isLocalRuntimeHost = (hostname = "") =>
  LOCAL_HOSTNAMES.has(hostname) ||
  hostname.endsWith(".local") ||
  isPrivateIpv4Host(hostname);

const toCurrentProtocolUrl = (value, protocol) =>
  value ? `${protocol}//${stripProtocol(value)}` : "";

export const getApiBaseUrl = () => {
  const protocol = getProtocol();
  const hostname = getHostname();

  if (isLocalRuntimeHost(hostname)) {
    return ensureTrailingSlash(
      toCurrentProtocolUrl(DEFAULT_STAGING_API_HOST, SECURE_PROTOCOL)
    );
  }

  const domainMappedApiHost = DOMAIN_API_HOST_ENUM[hostname];
  if (domainMappedApiHost) {
    return ensureTrailingSlash(toCurrentProtocolUrl(domainMappedApiHost, protocol));
  }

  return ensureTrailingSlash(toCurrentProtocolUrl(DEFAULT_STAGING_API_HOST, protocol));
};

export const buildApiUrl = (path = "") => {
  const normalizedPath = `${path}`.replace(/^\/+/, "");
  return `${getApiBaseUrl()}${normalizedPath}`;
};

export const getFrontendBaseUrl = () => {
  const protocol = getProtocol();
  const hostname = getHostname();

  if (isLocalRuntimeHost(hostname)) {
    return toCurrentProtocolUrl(DEFAULT_STAGING_FRONT_HOST, SECURE_PROTOCOL);
  }

  const mappedFrontHost = DOMAIN_FRONT_HOST_ENUM[hostname];
  if (mappedFrontHost) {
    return toCurrentProtocolUrl(mappedFrontHost, protocol);
  }

  return toCurrentProtocolUrl(DEFAULT_STAGING_FRONT_HOST, protocol);
};

export {
  DOMAIN_HOST_ENUM,
  DOMAIN_API_HOST_ENUM,
  DOMAIN_FRONT_HOST_ENUM,
  DEFAULT_STAGING_API_HOST,
  DEFAULT_STAGING_FRONT_HOST,
};
